// TabComponent.jsx
import React from 'react';

const DefaultTab = ({ label, content }) => {
    return (
        <div>
            <h2>{label}</h2>
            <div>{content}</div>
        </div>
    );
};

export default DefaultTab;
